







import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class AboutSwitcher extends Vue {

  displayAbout() {
    this.$emit('display-about')
  }

}
